import { Button, Checkbox, Collapse, Divider, Grid, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import debounce from 'lodash.debounce';
import React, { useCallback, useState } from 'react'
import { actualizarRolesYDepartamentos } from '../../../services/apis';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ordenarPorCampoTexto } from '../../../utils/utils';
// Componentes estilizados
const StickyTableCell = styled(TableCell)(({ theme }) => ({
    position: 'sticky',
    left: 0,
    backgroundColor: '#e53935',
    zIndex: 1,
}));

const StickyHeaderCell = styled(StickyTableCell)(({ theme }) => ({
    backgroundColor: '#e53935',
    zIndex: 2,
    width: '15em'
    // borderTop: '2px solid',
    // borderColor: '#e53935',
}));



export const PermisosOpciones = ({ roles, opciones, title, nombreArray, descripcion, index }) => {
    // Estado local para opciones con roles_permitidos
    const [opcionesTempOG, setOpcionesTempOG] = useState([...opciones]);
    const [opcionesTemp, setOpcionesTemp] = useState([...opciones]);
    const [open, setOpen] = useState(null);
    const [nombreOpciones, setNombreOpciones] = useState([...opciones])
    const textoMayusculas = (texto) => String(texto || '').toUpperCase();

    // Función para manejar el cambio en los permisos
    const handleCheckboxChange = (rolId, opcionId) => {
        // Actualizar el estado de las opciones al cambiar el checkbox
        const updatedOpciones = opcionesTemp.map((opcion) => {
            if (opcion.id === opcionId) {
                // Verificar si el rol ya está presente en roles_permitidos
                const isRolPresent = opcion.roles_permitidos.includes(rolId);
                // Si el rol está presente, lo eliminamos; si no, lo agregamos
                const updatedRolesPermitidos = isRolPresent
                    ? opcion.roles_permitidos.filter((id) => id !== rolId) // Eliminar rol
                    : [...opcion.roles_permitidos, rolId]; // Añadir rol
                return { ...opcion, roles_permitidos: updatedRolesPermitidos }; // Actualizamos la opción
            }
            return opcion; // Si no es la opción que se ha modificado, la dejamos igual
        });
        setOpcionesTemp(updatedOpciones);
        debouncedHandleSearch(updatedOpciones, rolId);
    };

    const actualizarPermisos = async (updatedOpciones, rolid) => {

        try {
            const response = await actualizarRolesYDepartamentos(updatedOpciones, nombreArray, rolid);

        } catch (error) {
            console.error('Error al cargar las opciones:', error);
        }
    }
    const debouncedHandleSearch = useCallback(debounce(actualizarPermisos, 1000), []);


    const buscarOpcion = (event) => {
        console.log("Buscando opción:", event.target.value.toLowerCase());

        const searchTerm = event.target.value.toLowerCase();

        if (searchTerm === "") {
            // Si el campo de búsqueda está vacío, puedes restaurar la lista original
            // Por ejemplo:
            setOpcionesTemp(opcionesTempOG);
            setNombreOpciones(opcionesTempOG);
            return;
        }

        const resultados = opcionesTempOG.filter(opcion => {
            return (
                opcion.nombre.toLowerCase().includes(searchTerm)
            );
        });

        const resultados2 = opciones.filter(opcion => {
            return (
                opcion.nombre.toLowerCase().includes(searchTerm)
            );
        });

        setNombreOpciones(resultados2);
        // Actualiza el estado con los resultados
        // Por ejemplo:
        setOpcionesTemp(resultados2);
        console.log("Resultados de búsqueda:", resultados);
    }


    return (
        <>
            {opciones && opciones.length >= 1 && (
                <Grid container direction={'row'} alignItems={'center'} justifyContent={'center'} xs={12}>
                    <Grid container direction={'column'} alignItems={'start'} justifyContent={'start'} xs={10}>
                        <Typography variant='h4' sx={{ mt: 4, textAlign: 'left' }}>
                            <Button variant='text' onClick={() => (index != open ? setOpen(index) : setOpen(null))}>
                                {
                                    index != open
                                        ? <VisibilityIcon sx={{ fontSize: 35, mt: -0.5 }} />
                                        : <VisibilityOffIcon sx={{ fontSize: 35, mt: -0.5 }} />
                                }
                            </Button>
                            {textoMayusculas(title)}
                        </Typography>
                        <Typography variant='body2' sx={{ mb: 3, mt: 1, textAlign: 'left' }}>
                            {descripcion}
                        </Typography>

                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={11.5} sm={11} md={10}
                    >
                        <Collapse in={open === index} fullWidth sx={{ overflow: 'auto', minWidth: '100%' }}>
                            <Grid container direction={'column'} alignItems={'center'} justifyContent={'center'} xs={12}>
                                {
                                    opcionesTempOG.length > 10
                                        ? <Grid container xs={12} sx={{ mb: 2 }}>
                                            <TextField id="standard-basic" label="Buscar..." variant="standard" size="small" name='search' fullWidth onChange={(event) => buscarOpcion(event)} />
                                        </Grid>
                                        : <></>
                                }

                                <TableContainer component={Paper} sx={{ minWidth: "100%" }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#e53935' }}>
                                                <StickyHeaderCell style={{ borderRight: '1px solid', borderRightColor: '#e0e0e0' }}>
                                                    <Typography variant='h6' sx={{ fontSize: 25, color: 'white' }}>
                                                        ROLES
                                                    </Typography>
                                                </StickyHeaderCell>
                                                {ordenarPorCampoTexto(nombreOpciones, 'nombre').map((opcion) => (
                                                    <TableCell key={opcion.id} align="center">
                                                        <Typography variant='h6' sx={{ fontSize: 15, color: 'white' }}>
                                                            {textoMayusculas(opcion.nombre)}
                                                        </Typography>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {/* Filas de roles */}
                                            {ordenarPorCampoTexto(roles, 'nombre').map((rol, indexRol) => (
                                                <TableRow key={rol.id} sx={{ backgroundColor: indexRol % 2 === 0 ? '#ffffff' : '#f7e2e1' }}>
                                                    {/* <TableCell sx={{ position: 'sticky' }}>
                                                <Typography variant='h6' sx={{ fontSize: 20 }}>
                                                    {rol.nombre}
                                                </Typography>
                                            </TableCell> */}
                                                    <StickyHeaderCell>
                                                        <Typography variant='h6' sx={{ fontSize: 20, color: 'white' }}>
                                                            {textoMayusculas(rol.nombre)}
                                                        </Typography>
                                                    </StickyHeaderCell>
                                                    {ordenarPorCampoTexto(opcionesTemp, 'nombre').map((opcion) => (
                                                        <TableCell key={`${rol.id}-${opcion.id}`} align="center">
                                                            <Checkbox
                                                                checked={opcion.roles_permitidos.includes(parseInt(rol.id))} // Verificar si el rol está en roles_permitidos
                                                                onChange={() => handleCheckboxChange(parseInt(rol.id), opcion.id)} // Manejar el clic
                                                            />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                        </TableBody>

                                    </Table>
                                </TableContainer>

                            </Grid>
                        </Collapse>
                    </Grid>

                    <Grid item xs={10}>
                        <Divider sx={{ minWidth: '100%', display: index === open ? 'none' : 'flex', transition: 'all ease 0.25s' }}></Divider>
                    </Grid>
                </Grid>
            )}
        </>
    );
};
